import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../collections/CollectionsKt.mjs';
import { listOfvhqybd2zx248 as listOf } from '../collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  TakeSequencecj2mz1r3ww35 as TakeSequence,
  DropTakeSequence18qfczyunxcax as DropTakeSequence,
  emptySequence25zpp7hgtqwdd as emptySequence,
  FlatteningSequence1gb46kmahgjp0 as FlatteningSequence,
  FilteringSequence3rfik2d45zn1y as FilteringSequence,
} from './Sequences.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { Iterable$iterator$ref3u1hw41cq8ldt as Iterable$iterator$ref } from '../collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function first(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Sequence is empty.');
  return iterator.next_20eer_k$();
}
function toList(_this__u8e3s4) {
  var it = _this__u8e3s4.iterator_jk1svi_k$();
  if (!it.hasNext_bitz1p_k$())
    return emptyList();
  var element = it.next_20eer_k$();
  if (!it.hasNext_bitz1p_k$())
    return listOf(element);
  var dst = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  dst.add_utx5q5_k$(element);
  while (it.hasNext_bitz1p_k$()) {
    dst.add_utx5q5_k$(it.next_20eer_k$());
  }
  return dst;
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  var tmp;
  if (n === 0) {
    tmp = emptySequence();
  } else {
    if (isInterface(_this__u8e3s4, DropTakeSequence())) {
      tmp = _this__u8e3s4.take_6gva4v_k$(n);
    } else {
      tmp = new (TakeSequence())(_this__u8e3s4, n);
    }
  }
  return tmp;
}
function flatMap(_this__u8e3s4, transform) {
  return new (FlatteningSequence())(_this__u8e3s4, transform, Iterable$iterator$ref());
}
function filter(_this__u8e3s4, predicate) {
  return new (FilteringSequence())(_this__u8e3s4, true, predicate);
}
function asIterable(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new (asIterable$$inlined$Iterable$1())(_this__u8e3s4);
}
var asIterable$$inlined$Iterable$1Class;
function asIterable$$inlined$Iterable$1() {
  if (asIterable$$inlined$Iterable$1Class === VOID) {
    class $ {
      constructor($this_asIterable) {
        this.$this_asIterable_1 = $this_asIterable;
      }
      iterator_jk1svi_k$() {
        return this.$this_asIterable_1.iterator_jk1svi_k$();
      }
    }
    initMetadataForClass($);
    asIterable$$inlined$Iterable$1Class = $;
  }
  return asIterable$$inlined$Iterable$1Class;
}
//region block: exports
export {
  asIterable as asIterable1fxmj7vyh9cyo,
  filter as filter184huxd00uyfg,
  first as firstqtqxwgtggxw8,
  flatMap as flatMap1gb3cjy1dqv3d,
  take as take2rh6pen3z50h7,
  toList as toListx6x8nvfmvvht,
};
//endregion

//# sourceMappingURL=_Sequences.mjs.map
